import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Form, DatePicker, TimePicker } from 'antd';
import './ScheduleForm.less';

const Schedule = (props) => {
  const { disabled, publishDate, handleRequest } = props;
  const [timeValue, setTimeValue] = useState(null);
  const [dateValue, setDateValue] = useState(null);
  const [dataReady, setDataReady] = useState(false);

  const setTime = () => {
    if (!publishDate) return;
    //  Parse the date to locale time
    const parseDate = moment(publishDate);
    // Set Values
    setDateValue(parseDate);
    setTimeValue(parseDate);
  };

  /**
   * UseEffect to get the publish data.
   */
  useEffect(() => {
    setTime();
  }, [publishDate]);

  const onChangeTime = (time) => {
    setTimeValue(time);
  };

  const onChangeDate = (date) => {
    setDateValue(date);
  };

  const dateFormat = 'DD/MM/YYYY';

  useEffect(() => {
    if (!timeValue || !dateValue) {
      if (dataReady) setDataReady(false);
      return;
    }
    setDataReady(true);
  }, [timeValue, dateValue]);

  /*
   * Joins the date with the time in order to send it to the flight service.
   * the format function return the moment object like  2020-01-09T20:23:47-06:00
   */
  const createDate = () => {
    const dateTemp = dateValue.format().substring(0, 11);
    const timeTemp = timeValue.format().substring(11, 19);
    return dateTemp + timeTemp;
  };

  const handleSubmit = () => {
    if (dataReady) {
      const finalDate = createDate();
      handleRequest({ publish_date: finalDate });
    } else {
      handleRequest({ error: !(!timeValue && !dateValue) });
    }
  };

  return (
    <div>
      <Form onSubmit={handleSubmit} onBlur={handleSubmit}>
        <div className="post-date-publish">
          <DatePicker
            value={dateValue}
            format={dateFormat}
            className="post-date-input"
            disabled={disabled}
            onChange={onChangeDate}
            placeholder="Fecha"
          />
          <div className="post-date-characters">@</div>
          <TimePicker value={timeValue} className="post-time-input" disabled={disabled} onChange={onChangeTime} placeholder="Hora" />
        </div>
      </Form>
    </div>
  );
};

Schedule.propTypes = {
  disabled: PropTypes.bool.isRequired,
  publishDate: PropTypes.string,
  handleRequest: PropTypes.func.isRequired,
};

Schedule.defaultProps = {
  publishDate: false,
};

const ScheduleForm = Form.create({ name: 'Schedule' })(Schedule);

export default ScheduleForm;
